import axios from 'axios';
import { supabase } from './supabase';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Main API instance with automatic token management
const api = axios.create({ baseURL: API_BASE });

// Request interceptor: always get the freshest token from Supabase
api.interceptors.request.use(async (config) => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      config.headers.Authorization = `Bearer ${session.access_token}`;
    }
  } catch {
    // Session unavailable (signed out) — proceed without auth header
  }
  return config;
});

// Response interceptor: on 401, refresh token and retry once
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const { data: { session } } = await supabase.auth.refreshSession();
        if (session?.access_token) {
          originalRequest.headers.Authorization = `Bearer ${session.access_token}`;
          return api(originalRequest);
        }
      } catch {
        // Refresh failed (signed out or expired) — don't retry
      }
    }
    return Promise.reject(error);
  }
);

export { api, API_BASE };
